import { NoteOutlineIcon } from './NoteOutlineIcon';

/**
 * author: Austin Andrews
 * id DD6D5075-A7F5-4183-9F99-93C295F18B0B
 * name note-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/note-outline.svg
 * tags
 */
export const PostItNoteOutlineIcon = NoteOutlineIcon;
export default PostItNoteOutlineIcon